
<template>
  <div>
    <!-- <div class="guibe" v-if="view">
      <img
        class="img"
        src="https://file.modehoist.com/gowow/website/20240418-ori.png"
        alt=""
      />
      <div class="info">
        <div class="infotext">Gowow</div>
        <div class="infotext">ORI</div>
        <div class="infotext" style="margin: 10px 0">
          {{ $t("index.RMB35,700") }}
        </div>
        <div class="infobtn" @click="changeView">
          {{ $t("index.了解详情") }}
        </div>
      </div>
    </div> -->
    <div class="wrap" >
      <div class="slide slide1">
        <img class="img" src="https://file.modehoist.com/gowow/website/240718/product/product1.jpg" alt="" />
        <div class="title">
          <div class="first">ORI</div>
          <div class="last" v-if="isCN">
            {{ $t("product.ORI") }} {{ $t("index.全国统一零售价35,700RMB") }}
          </div>
          <ul style="display: flex; width: 100%; justify-content: center">
            <li class="see-video-btn" @click="gotrial">
              {{ $t("index.预约试驾") }}
            </li>
            <li class="see-video-btn">
              <a href="#par" style="color: white">{{
                $t("slides.全部参数")
              }}</a>
            </li>
          </ul>
        </div>
        <ul class="bottom">
          <li>
            <p><span class="number">73</span>Kg</p>
            <p>{{ $t("slides.整车重量设计") }}</p>
            <p>{{ $t("slides.轻量化灵动") }}</p>
          </li>
          <li>
            <p><span class="number">100</span>Km</p>
            <p>{{ $t("slides.高效续航") }}</p>
            <p>{{ $t("slides.3小时快速充电") }}</p>
          </li>
          <li>
            <p><span class="number">420</span>Nm</p>
            <p>{{ $t("slides.最大扭矩") }}</p>
            <p>{{ $t("slides.动力充沛") }}</p>
          </li>
        </ul>
      </div>

      <div class="slide slide2">
        <img class="img" src="https://file.modehoist.com/gowow/website/240718/product/product2.png" alt="" />
        <div class="desc-wrap">
          <div class="desc1">
            <div>{{ $t("slides.为探索而生") }}</div>
            <div>{{ $t("slides.创造无限的可能，创造自由的骑行") }}</div>
          </div>
        </div>
      </div>

      <div class="slide slide3"
        ref="bikeDisplay"
        @mouseover="changeCursor(true)"
        @mouseleave="changeCursor(false)"
      >
        <div v-drag="{ fn1, fn2 }">
          <div v-for="n in 36" :key="n-1" v-show="(n-1) === slide3.num_vr">
            <img
              
              :src="require('@assets/imgs/vrspin/' + (n-1) + '.png')"
              
              @mousedown.prevent=""
            />
          </div>
        </div>
      </div>

      <div class="slide slide4">
        <div class="title">
          <p class="bold">{{ $t("slides.极简设计") }}</p>
          <p>{{ $t("slides.次世代外观") }}</p>
        </div>
        <div class="carousel-container">
          <div @click="prev" class="carousel-button left-button">
            <img src="@assets/imgs/footerM-icon/right.png">
          </div>
          <div class="carousel-wrapper">
            <div class="carousel-track" :style="{ transform: `translateX(-${slide4.currentIndex * 506}px)`, transitionDuration: 1 + 's' }">
              <div class="carousel-item" v-for="(partName, index) in slide4.partName" :key="index">
                <img :src="'https://file.modehoist.com/gowow/website/240718/product/product4/' + (index+1) + '.png'">
                <p>{{ index === 0 ? "ORI": $t(`slides.${partName}`)}}</p>
              </div>
            </div>
          </div>
          <div @click="next" class="carousel-button right-button">
            <img src="@assets/imgs/footerM-icon/right.png" >
          </div>
        </div>
        
      </div>

      <div class="slide slide5">
        <div class="title">{{ $t("slides.灿若星空 设计理念") }}</div>
      
        <div class="image-container">

          <div
            class="image-wrapper"
            @mouseover="slide5.hoverIndex = 1"
            @mouseleave="slide5.hoverIndex = 0"
          >
            <img src="https://file.modehoist.com/gowow/website/240718/product/product5a.png" />
            <div class="overlay" :class="{ 'active': slide5.hoverIndex === 1 }"></div>
            <div class="text-overlay " :class="{ 'active': slide5.hoverIndex === 1 }">
              <p class="point" >{{ $t("slides.轻量化") }}</p>
              <p v-if="slide5.hoverIndex === 1" class="detail">{{$t("slides.前后配重比例50：50") }}</p>
            </div>
          </div>
          <div
            class="image-wrapper"
            @mouseover="slide5.hoverIndex = 2"
            @mouseleave="slide5.hoverIndex = 0"
          >
            <img src="https://file.modehoist.com/gowow/website/240718/product/product5b.png" />
            <div class="overlay" :class="{ 'active': slide5.hoverIndex === 2 }"></div>
            <div class="text-overlay " :class="{ 'active': slide5.hoverIndex === 2 }">
              <p class="point" >{{ $t("slides.骑行三角点") }}</p>
              <p v-if="slide5.hoverIndex === 2" class="detail">{{$t("slides.反复进行越野实验的人体工程学三角参数") }}</p>
            </div>
          </div>
          <div
            class="image-wrapper"
            @mouseover="slide5.hoverIndex = 3"
            @mouseleave="slide5.hoverIndex = 0"
          >
            <img src="https://file.modehoist.com/gowow/website/240718/product/product5c.png" />
            <div class="overlay" :class="{ 'active': slide5.hoverIndex === 3 }"></div>
            <div class="text-overlay " :class="{ 'active': slide5.hoverIndex === 3 }">
              <p class="point" >{{ $t("slides.操控性") }}</p>
              <p v-if="slide5.hoverIndex === 3" class="detail">{{$t("slides.26°前倾角，780mm宽车把，指向灵活，直线稳定") }}</p>
            </div>
          </div>
          
        </div>
      </div>

      <div class="slide slide6">
        <div class="top">
          <div class="title">{{ $t("slides.星空深邃 越野性能") }}</div>
          <img src="https://file.modehoist.com/gowow/website/240718/product/product6a.png" />
          <p>
            <span class="bold">{{ $t("slides.锻造双翼梁复合车架") }}</span>
            <br /><span>{{ $t("slides.全铝车架，轻盈，提升操控感受") }}</span>
          </p>
        </div>
        <div class="bottom">
          <div>
            <img src="https://file.modehoist.com/gowow/website/240718/product/product6b.png" />
            <p>
              <span class="bold">{{ $t("slides.四连杆后避震系统") }}</span
              ><br />
              <span>{{
                $t(
                  "slides.独特的四连杆式避震系统可以在不同下压力下均获得良好的抓地力和避震能力"
                )
              }}</span>
            </p>
          </div>
          <div>
            <img src="https://file.modehoist.com/gowow/website/240718/product/product6c.png" />
            <p>
              <span class="bold">{{ $t("slides.刹车") }}</span
              ><br />
              <span>{{
                $t(
                  "slides.一体式四活塞卡钳，配合203*28加厚碟盘，提供强大刹车性能"
                )
              }}</span>
            </p>
          </div>
        </div>
      </div>
      <div class="slide slide7">
        <div class="content">
          <p class="title">{{$t("slides.三大模式 - 动力强劲")}}</p>
          <div class="img-container">
            <div class="img-wrapper">
              <img src="https://file.modehoist.com/gowow/website/240718/product/product7b.png">
            </div>
            <div class="img-wrapper">
              <img src="https://file.modehoist.com/gowow/website/240718/product/product7c.png">
            </div>
            <div class="img-wrapper">
              <img src="https://file.modehoist.com/gowow/website/240718/product/product7d.png">
            </div>
          </div>
        </div>
      </div>
      <div class="slide slide8">
        <div class="title">{{ $t("slides.可适应多种场景") }}</div>
        <div class="img-container">
          <div class="img-wrapper">
            <img src="https://file.modehoist.com/gowow/website/240718/product/product8a.png">
            <span>
              {{ $t("slides.公路") }}
            </span>
          </div>
          <div class="img-wrapper">
            <img src="https://file.modehoist.com/gowow/website/240718/product/product8b.png">
            <span>
              {{ $t("slides.林道") }}
            </span>
          </div>
        </div>
        <div class="img-container">
          <div class="img-wrapper">
            <img src="https://file.modehoist.com/gowow/website/240718/product/product8c.png">
            <span>
              {{ $t("slides.沙漠") }}
            </span>
          </div>
          <div class="img-wrapper">
            <img src="https://file.modehoist.com/gowow/website/240718/product/product8d.png">
            <span>
              {{ $t("slides.泥路") }}
            </span>
          </div>
        </div>
      </div>
      <div class="slide slide9">
        <div class="content-container">
          <div class="left">
            <img src="https://file.modehoist.com/gowow/website/240718/product/product9b.png" />
          </div>
          <div class="right">
            <div class="text-wrapper">
              <p class="title">{{ $t("slides.可拆卸替换电池") }}</p>
              <p>- {{ $t("slides.大电池，更持久的续航") }}</p>
              <p>- {{ $t("slides.三年质保") }}</p>
            </div>
            <div class="text-wrapper">
              <p class="title"> 2.8kWh</p>
              
            </div>
          </div>
        </div>
      </div>
      <div class="slide slide10">
        
        <p class="title">{{ $t("slides.流星电掣 动力系统") }}</p>
        <div class="content">
          <div class="left">
            <img src="https://file.modehoist.com/gowow/website/240718/product/product10a.png" />
            <div class="text-wrapper">
              
              <p class="bold">{{ $t("slides.高效能电控") }}</p>
              <p >{{ $t("slides.具备四种动力模式可选，动力曲线可自定义调整、四种场景模式选择、速度自定义、boost一键冲刺等多种功能") }}</p>
            </div>
          </div>
          <div class="right">
            <div class="wrapper">
              <img src="https://file.modehoist.com/gowow/website/240718/product/product10b.png" />
              <div class="text-wrapper">
                
                <p class="bold">{{ $t("slides.高容量电池芯组") }}</p>
                <p>{{ $t("slides.自研锂电池芯，21700电芯") }}</p>
              </div>  
            </div>
            <div class="wrapper bottom">
              <img src="https://file.modehoist.com/gowow/website/240718/product/product10c.png" />
              <div class="text-wrapper">
                <p class="bold">{{ $t("slides.高性能电机") }}</p>
                <p>{{ $t("slides.PMSM永磁同步电机，最终轮端扭矩420Nm，最高速度") }}  100 km/h</p>
              </div>
            </div>
          </div>            
        </div>
      </div>
      <DownLoad product="Ori" />
      <div class="slide slide11">
        <img src="https://file.modehoist.com/gowow/website/240718/product/product11.png" />
        <div> 
          <p class="title">{{ $t("slides.车主权益") }}</p>
          <p>{{ $t("slides.整车质保1年") }}</p>
          <p>{{ $t("slides.俱乐部活动") }}</p>
        </div>
      </div>
      <div class="slide slide12">
        <div class="title">{{ $t("slides.包含内容") }}</div>
        <div class="content">
          <div class="img-container">
            <div class="img-wrapper">
              <img src="https://file.modehoist.com/gowow/website/240718/product/product12/1.png">
              <p>{{ $t("index.产品说明书") }} </p>
            </div>
            <div class="img-wrapper">
              <img src="https://file.modehoist.com/gowow/website/240718/product/product12/2.png">              
              <p>{{ $t("slides.充电器") }}</p>
            </div>
            <div class="img-wrapper">
              <img src="https://file.modehoist.com/gowow/website/240718/product/product12/3.png">              
              <p>{{ $t("slides.左脚踏板") }}</p>
            </div>
            <div class="img-wrapper">
              <img src="https://file.modehoist.com/gowow/website/240718/product/product12/4.png">              
              <p>{{ $t("slides.右脚踏板") }}</p>
            </div>
            <div class="img-wrapper">
              <img src="https://file.modehoist.com/gowow/website/240718/product/product12/5.png">              
              <p>{{ $t("slides.后视镜") }}({{ $t("slides.街道版本") }})</p>
            </div>
          </div>
        
          <div class="img-container">
            <div class="img-wrapper">
              <img src="https://file.modehoist.com/gowow/website/240718/product/product12/6.png">              
              <p>4mm {{ $t("slides.内六角扳手") }}</p>
            </div>
            <div class="img-wrapper">
              <img src="https://file.modehoist.com/gowow/website/240718/product/product12/6.png">              
              <p>5mm {{ $t("slides.内六角扳手") }}</p>
            </div>
            <div class="img-wrapper">
              <img src="https://file.modehoist.com/gowow/website/240718/product/product12/7.png">              
              <p>13mm {{ $t("slides.开口扳手") }}</p>
            </div>
            <div class="img-wrapper">
              <img src="https://file.modehoist.com/gowow/website/240718/product/product12/7.png">              
              <p>14mm {{ $t("slides.开口扳手") }}</p>
            </div>
            <div class="img-wrapper">
              <img src="https://file.modehoist.com/gowow/website/240718/product/product12/7.png">              
              <p>15mm {{ $t("slides.开口扳手") }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="slide slide13">
        <div class="title">{{ $t("slides.基本参数") }} <a name="par"></a></div>
        <div class="icon">
          <div>
            <li><img src="@assets/imgs/product/Sit high_icon.png" /></li>
            <p class="bold">{{ $t("slides.座高") }}</p>
            <p>890mm</p>
          </div>
          <div>
            <li><img src="@assets/imgs/product/Battery_icon.png" /></li>
            <p class="bold">{{ $t("slides.电池容量") }}</p>
            <p>2.8kWh</p>
          </div>
          <div>
            <li><img src="@assets/imgs/product/weight_icon.png" /></li>
            <p class="bold">{{ $t("slides.整车质量") }}</p>
            <p>73kg</p>
          </div>
          <div>
            <li><img src="@assets/imgs/product/tyre_icon.png" /></li>
            <p class="bold">{{ $t("slides.轮胎") }}</p>
            <p>{{ $t("slides.前 70/100-19") }}</p>
            <p>{{ $t("slides.后 350-18") }}</p>
          </div>
        </div>
        <div class="content">
          <div>
            <li>
              <p class="bold">1900mm/780mm/1100mm</p>
              <p>{{ $t("slides.长宽高") }}</p>
            </li>
            <li>
              <p class="bold">280mm</p>
              <p>{{ $t("slides.离地间隙") }}</p>
            </li>
            <li>
              <p class="bold">100kg</p>
              <p>{{ $t("slides.最大载重") }}</p>
            </li>
          </div>
          <div>
            <li>
              <p class="bold">1275mm</p>
              <p>{{ $t("slides.轴距") }}</p>
            </li>
            <li>
              <p class="bold">210mm</p>
              <p>{{ $t("slides.前轮行程") }}</p>
            </li>
            <li>
              <p class="bold">210mm</p>
              <p>{{ $t("slides.后轮行程") }}</p>
            </li>
          </div>
          <div>
            <li>
              <p class="bold">9kW</p>
              <p>{{ $t("slides.峰值功率") }}</p>
            </li>
            <li>
              <p class="bold">420Nm</p>
              <p>{{ $t("slides.驱动轮端扭矩") }}</p>
            </li>
            <li>
              <p class="bold">55°@10km/h</p>
              <p>{{ $t("slides.爬坡角度") }}</p>
            </li>
          </div>
          <div>
            <li>
              <p class="bold">100km/h</p>
              <p>{{ $t("slides.最高速度") }}</p>
            </li>
            <li>
              <p class="bold">100km</p>
              <p>{{ $t("slides.续航里程") }}</p>
            </li>
            <li>
              <p class="bold" >
                80%: 2h @220V  
              </p>
              <p>{{ $t("slides.充电时间") }}</p>
            </li>
          </div>
        </div>
      </div>
      <!-- <Swiper /> -->
    </div>
    <FloatBall v-if="true" />
  </div>
</template>

<script>
import FloatBall from '@/pages/product/FloatBall';
import cursorIcon from '@/assets/imgs/vrspin/cursor-360.png';
import DownLoad from "../../../../index/components/DownLoad";
// import Swiper from "@components/Swiper.vue";
import { goto } from "@utils/goto";
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(["lang"]),
    isCN() {
      return this.lang === "zh-CN";
    },
  },
  components: {
    FloatBall,
    DownLoad,
    // Swiper,
  },
  data() {
    return {
      tabPosition: "left",
      view: true,
      slide3: {
        num_vr: 0,
        movex_vr: 0,
      },
      slide4: {
        currentIndex: 0,
        partName:["ORI","前轮","后轮","前避震","后避震","电机","电控","电芯","仪表"],
      },
      slide5:{
        hoverIndex: 0
      },
      
      
    };
  },
  methods: {
    gotrial() {
      goto("/trial");
    },
    changeView() {
      this.view = false;
    },
    fn1(val) {
      this.slide3.num_vr = (((this.slide3.movex_vr + val) % 36) + 36) % 36;
    },
    fn2() {
      this.slide3.movex_vr = this.slide3.num_vr;
    },
    preloadImages() {
      for (let i = 0; i < 36; i++) {
        new Image().src = require(`@assets/imgs/vrspin/${i}.png`);
      }
    },
    changeCursor(isHovering) {
      const slide = this.$refs.bikeDisplay;
      if (isHovering) {
        slide.style.cursor = `url(${cursorIcon}), auto`;
      } else {
        slide.style.cursor = "move";
      }
    },
    next() {
      if (this.slide4.currentIndex < this.slide4.partName.length - 2) {
        this.slide4.currentIndex++;
      } else {
        this.slide4.currentIndex = 0
      }
    },
    prev() {
      if (this.slide4.currentIndex > 0) {
        this.slide4.currentIndex--;
      } else {
        this.slide4.currentIndex = this.slide4.partName.length - 2;
      }
    }
  },
  mounted() {
    this.preloadImages();
  },
  directives: {
    drag: {
      // 指令的定义
      inserted: function (el, bindings) {
        // el.drag();
        const { fn1, fn2 } = bindings.value;
        // console.log(el, bindings);
        //获取元素
        // var dv = document.getElementById("dv");
        let x = 0;
        let l = 0;
        let isDown = false;
        //鼠标按下事件
        el.onmousedown = function (e) {
          //获取x坐标
          x = e.clientX;
          //获取左部的偏移量
          l = el.offsetLeft;
          //开关打开
          isDown = true;
        };
        //鼠标移动
        window.onmousemove = function (e) {
          if (isDown == false) {
            return;
          }
          //获取x
          let nx = e.clientX;
          //计算移动后的左偏移量
          let nl = parseInt((nx - (x - l)) / 15);
          fn1(nl);
        };
        //鼠标抬起事件
        el.onmouseup = function () {
          //开关关闭
          isDown = false;
          fn2();
        };
      },
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@assets/styles/vars.scss";
@import "~@assets/styles/mixin.scss";
@import "~@assets/styles/func.scss";
* {
  margin: 0;
  padding: 0;
}
img {
  vertical-align: top;
}
.guibe {
  position: relative;
  img {
    width: 100vw;
    height: 100vh;
    object-fit: cover;
  }
  .info {
    position: absolute;
    bottom: 20vh;
    left: 10vw;
    color: #ffffff;
    .infotext {
      font-size: 40px;
      font-weight: 700;
      text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
      text-align: left;
      font-style: normal;
      text-transform: none;
    }
    .infobtn {
      background-color: rgba(250, 190, 0, 0.98);
      font-size: 20px;
      display: inline-block;
      padding: 6px 30px;
      border-radius: 30px;
      cursor: pointer;
    }
}
}
.wrap {
  width: 100vw;
  overflow: hidden;
}
.slide1 {
  position: relative;
  display: flex;
  flex-direction: column;
  > .img {
    width: 100%;
    height: auto;
  }
  > .title {
    width: 100vw;
    text-align: center;
    position: absolute;
    top: 60px;
    // left: 74px;
    color: #ffffff;
    text-transform: uppercase;
    .see-video-btn {
      &:first-child{
        border: 0;
        background-color: white;
        color: black;
      }
      &:last-child{
        border: 2px solid rgba(255, 255, 255, 1);
      }
      cursor: pointer;
      margin: 20px 20px 0;
      @include flex-center("row");
      min-width: 170px;
      height: 40px;
      padding: 0 10px;
      font-size: 14px;
      font-weight: 400;
      font-family: PingFang-SC-Medium;
      border-radius: 2px;
    }
    div:first-child {
      font-size: 100px;
      font-family: PingFang-SC-Heavy;
      font-weight: normal;
      line-height: 120px;
      margin-bottom: 8px;
    }
    div:last-child {
      font-size: 20px;
      font-family: PingFang-SC-Medium;
      font-weight: Medium;
      line-height: 24px;
    }
  }
  .bottom {
    width: 100%;
    position: absolute;
    bottom: 30px;
    color: #ffffff;
    display: flex;
    justify-content: space-evenly;
    li {
      width: 20%;
      text-align: center;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 500;

      .number {
        font-size: 50px;
        font-family: Helvetica Neue LT Pro;
        font-weight: normal;
      }
    }
  }
}
.slide2 {
  position: relative;
  display: flex;
  flex-direction: column;
  > .img {
    width: 100%;
    height: auto;
  }
  .desc-wrap {
    position: absolute;
    bottom: 100px;
    left: 120px;
    display: flex;
    justify-content: space-between;
  }
  .desc1 {
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #d48b22;
    div:nth-child(1) {
      font-size: 35px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      line-height: 80px;
    }
  }
}
.slide3{
  position: relative;
  overflow: hidden;
  img {
    margin-top: -5%;
    width: 100%;
    height: auto;
    
  }
}
.slide4 {
  position: relative;
  
  .title {
    padding-top: 20px;
    text-align: center;
    p {
      font-size: 24px;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
    }
    .bold {
      font-size: 40px;
      font-family: PingFang SC;
      font-weight: 500;
      line-height: 64px;
      color: rgba(51, 51, 51, 1)
      ;
    }
  }
  .carousel-container {
    position: relative;
    width: 100%;
    padding: 0 50px;
    margin-top: 30px;
    overflow: hidden;
    .carousel-button {
      position: absolute;
      top: calc(50% - 30px);
      background-color: rgba(0, 0, 0, 0.1);
      border: none;
      cursor: pointer;
      z-index: 1;
      width: 80px;
      height: 80px;
      &:hover {
        background-color: rgba(0, 0, 0, 0.3);
      }
      img {
        width: 100%;
        height: auto;
      }
    }

    .left-button {
      left: 50px;
      transform: scaleX(-1);
    }

    .right-button {
      right: 50px;
    }
    .carousel-wrapper {
      width: 100%;
      overflow: hidden;
      .carousel-track {
        display: flex;
        // transition: transform ease; /* Apply the transition timing function */
        /* Set the gap between items */
        .carousel-item {
          margin-right: 20px;
          p {
            font-size: 24px;
            line-height: 50px;
            font-family: PingFang SC;
            font-weight: 400;
            text-align: center;
            color: rgba(51, 51, 51, 1);
          }
          img {
            
            display: block;
        }

      }
    }

  }
}
  
}
.slide5 {
  margin-top: 40px;
  position: relative;

  .title {
   
    color:rgba(51, 51, 51, 1);
    font-size: 40px;
    font-family: PingFang SC;
    font-weight: 500;
    text-align: center;
    line-height: 64px;
  }

  .image-container {
    display: flex;
    justify-content: center;
    
    margin: 20px 40px;
    .image-wrapper {
      position: relative;
      img {
        width: 100%;
        height: auto;
      }
      .overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    
        &.active {
          background: linear-gradient(180deg, rgba(0, 0, 0, 0) 27.46%, #000000 100%);
        }
      }
      .text-overlay {
        position: absolute;
        display: flex;
        width: 100%;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        top:75%;
        &.active {
          top: 50%;
        }
        .point {
          font-size: 2.5vw;
          font-family: PingFang SC;
          font-weight: 500;
          color: #ffffff;
          line-height: 3vw;
          margin-bottom: 1.5vw;
        }
        .detail {
          font-size: 1.5vw;
          font-family: PingFang SC;
          font-weight: 400;
          color: #ffffff;
          line-height: 2vw;
          padding: 0 20%;
          text-align: center
        }
      }
    }
  }


}
.slide6{
  position: relative;
  display: flex;
  flex-direction: column;
  .bold {
    font-size: 22px;
    font-weight: 600;
    line-height: 60px;
    color:rgba(51, 51, 51, 1);
  }
  .top {
    position: relative;
    img {
      width: 100%;
      height: auto;
    }

    .title {
      color:rgba(51, 51, 51, 1);
      font-size: 40px;
      font-family: PingFang SC;
      font-weight: 500;
      text-align: center;
      line-height: 64px;
      width: 100vw;
      text-align: center;
      font-family: PingFang SC;
      margin-bottom: 30px;
      margin-top: 30px
    }
    p {
      width: 100%;
      position: absolute;
      bottom: 5vh;
      text-align: center;
      font-size: 16px;
      color: rgba(102, 102, 102, 1);
    }
  }
  .bottom {
    margin: 7vh 0;
    display: flex;
    justify-content: space-evenly;
    font-size: 16px;
    color: rgba(102, 102, 102, 1);
    div {
      width: 40vw;
    }

    img {
      width: 40vw;
      height: auto;
    }
  }
}
.slide7{
  position: relative;
  margin-top: 30px;  
  background-image: url("https://file.modehoist.com/gowow/website/240718/product/product7a.png");
  background-size: cover;     

  .content{
    
    display: flex;
    flex-direction: column;
    justify-content: end;
    margin: 0 40px;
    .title{
      color:rgba(51, 51, 51, 1);
      font-size: 40px;
      font-family: PingFang SC;
      font-weight: 500;
      text-align: center;
      line-height: 64px;
      font-family: PingFang SC;
      margin-bottom: 30px;
      margin-top: 30px
    }
    .img-container{

      display: flex;
      justify-content: center;
      .img-wrapper{
        flex:1;
        img{
          width: 100%;
          height: auto;
          
        }
      }
      
    }
  }
}
.slide8{
  position: relative;
  margin-top: 30px;
  .title{
    color:rgba(51, 51, 51, 1);
    font-size: 32px;
    font-family: PingFang SC;
    font-weight: 500;
    text-align: center;
    line-height: 48px;
    font-family: PingFang SC;
    margin-bottom: 30px;
  }
  .img-container{
    display: flex;
    justify-content: center;
    margin:0 40px 40px 40px;
    .img-wrapper{
      flex: 1;
      margin: 0 20px;
      position: relative;
      img{
        width: 100%;
        height: auto;
      }
      span{
        position: absolute;
        right: 5px;
        bottom: 5px;
        font-size: 20px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #ffffff;
      }
    }
  }
  
}
.slide9{
  position: relative;
  background-image: url("https://file.modehoist.com/gowow/website/240718/product/product9a.png");
  background-size: cover;
  overflow: hidden;
  .content-container{
  display: flex;
  justify-content: center;
  align-items: center;
  margin:50px 50px;
  .left{
    padding-right: 5vw;
    width: 45vw;
    img{
      width: 100%;
    }
  }
    
  
  .right{
    width: 40vw;
    display: flex;
    justify-content: center;
    flex-direction: column;
    .text-wrapper{
      margin: 30px 0;
      color: rgba(51, 51, 51, 1);
      p{
        font-size: 1.6vw;
        font-family: PingFang SC;
        font-weight: 400;
        line-height: 2.8vw;
      }
      .title{
        font-size :2.3vw;
        font-family: PingFang SC;
        font-weight: 500;
        line-height: 4.5vw;
      }
      .bold{
        font-weight: 500;
      }
    }
  }
  }  
  
}
.slide10 {
  margin-block: 40px;
  position: relative;
  display: flex;
  flex-direction: column;
  .title {
    width: 100vw;
    text-align: center;
    font-size: 40px;
    font-family: PingFang SC;
    font-weight: 500;
    line-height: 64px;
  }
  .content {
    display: flex;
    justify-content: center;
    margin: 30px 0;
    p{
      font-family: PingFang SC;
          font-weight: 400;
          line-height: 30px;
          font-size: 16px;
          color: rgba(102, 102, 102, 1);

    }
    .bold {
            font-size: 24px;
            font-weight: 500;
            color: #000000;
            line-height: 40px;
    }
    .left {
      background-color:rgba(245, 245, 245, 1) ;
      width: 30vw;
      margin-right: 10px;
      text-align: center;
      img {
        width: 100%;
        height: auto;
      }
      .text-wrapper {
        padding: 0 10px;
      }
    }
    .right {
      display: flex;
      justify-content: space-between;

      flex-direction: column;
      .wrapper {
        padding: 30px 0;
        display: flex;
        background-color: rgba(245, 245, 245, 1);
        width: 50vw;
        align-items: center;
        img {
          width: 50%;
          height: auto;
        }
        .text-wrapper {
          width: 50%;
          
        }
      }
      .bottom {
        margin-top: 20px;
      }
    }
  }
}

.slide11 {
  position: relative;
  width: 100vw;
  div {
    width: 100%;
    position: absolute;
    text-align: center;
    top: 40%;
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #000000;
    line-height: 4vh;
    .title {
      font-size: 40px;
      font-weight: 500;
      line-height: 13vh;
    }
  }
  img {
    width: 100vw;
    height: auto;
  }
}
.slide12{
  position: relative;
  background-color: #F4F4F4;
  overflow: hidden;
  .title{
    color:rgba(51, 51, 51, 1);
    font-size: 40px;
    font-family: PingFang SC;
    font-weight: 500;
    text-align: center;
    line-height: 64px;
    font-family: PingFang SC;
    margin-top: 30px;
  }
  .content{
  
    padding: 30px 50px;
    .img-container{
      display: flex;
      margin-bottom: 30px;
      .img-wrapper{
        background: white;
        flex: 1;
        margin: 0 20px;
        padding: 30px 10px 15px 10px;
        text-align: center;
        img{
          width: auto;
          height: 5vw;
          margin-bottom: 30px;
        }
        p{
          min-height: 3.2vw;
          font-size: 1.3vw;
          font-family: PingFang SC;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
        }
      }
    }
  }
}
.slide13 {
  width: 100vw;
  margin-bottom: 5vh;
  .title {
    width: 100%;
    text-align: center;
    font-size: 32px;
    font-family: PingFang SC;
    font-weight: 500;
    line-height: 30vh;
  }
  .icon {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-bottom: 8vh;
    div {
      width: 17vw;
      height: auto;
      text-align: center;
      border: #000000 solid 2px;
      border-radius: 6px;
      padding: 1vw 0;
      margin: 0 3vw;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 400;
      .bold {
        font-size: 24px;
        font-weight: 500;
      }
      li {
        // height: 12vh;
        list-style: none;
      }
    }
  }
  .end {
    li {
      .bold {
        height: 15vh;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
  .content {
    background: #f7f7f7;
    width: 90vw;
    padding: 4vh 0;
    margin: 0 auto;
    div {
      display: flex;
      justify-content: center;
      text-align: center;
      margin: 8vh 0;
      li {
        list-style: none;
        width: 30%;
        p:last-child {
          margin-top: 2vh;
        }
        .bold {
          font-size: 24px;
          font-family: PingFang SC;
          font-weight: bold;
        }
      }
    }
  }
}





</style>
